import { fetchApi } from 'utils/request';

export const fetchRemainingTime = (): Promise<CF.API.Users.IRemainingTimeResponse> =>
  fetchApi({
    path: `/api/_api/v2/users/me/remaining_runtime`,
    method: 'GET',
  });
